import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import { useState, useEffect } from "react"
import * as endPoints from '../Constants/Endpoints'

export const useAuth = () => {
    const [isAuth, setIsAuth] = useState(null);
    const location = useLocation();
    const allowedRoutes = ['/page-register', '/client-site', '/make-a-booking', '/login', '/landing-page', '/cancel-appointment', '/request-forgot-password', "/reset-password"]
    useEffect(() => {
        if (!allowedRoutes.includes(location.pathname))
        {
            const fetchData = async () => {
                try {
                    const res = await axios.get(process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Authenticated, {
                        withCredentials: true
                    })
                    setIsAuth(false);
                    if (res.status === 200){
                        setIsAuth(true);
                    }
                }
                catch(e) {
                    setIsAuth(false);
                }
            };
            fetchData();
        }

    }, []);
return isAuth;
}

const ProtectedRoute = ({ children }) => {
    const isAuth = useAuth();
    let location = useLocation();
    if (isAuth === null)
    return null;
    return isAuth ?
        children :
        location.pathname === '/cancel-appointment' ?
        <Navigate to="/cancel-appointment" /> :
        location.pathname === '/request-forgot-password' ?
        <Navigate to="/request-forgot-password" /> :
        location.pathname === '/reset-password' ?
        <Navigate to="/reset-password" /> :
        location.pathname === '/page-register' ?
        <Navigate to="/page-register" /> :
        location.pathname === '/make-a-booking' ? 
        <Navigate to="/make-a-booking" /> : 
        location.pathname === '/client-site' ? 
        <Navigate to="/client-site" /> : 
        location.pathname === '/landing-page' ? 
        <Navigate to="/landing-page" /> :
        <Navigate to="/login" />;
};

export default ProtectedRoute;